export enum VatRate {
  RATE_23 = '23',
  RATE_8 = '8',
  RATE_0 = '0',
  NOT_SUBJECT = 'np',
  EXEMPT = 'zw',
}
